export default {
    admin_email: "Correo electrónico: ",
    admin_phone: "Teléfono: ",
    chatbot: {
        for_fastest_response:
            "Para una respuesta más rápida, intente usar nuestro bot de chat en la parte inferior izquierda, la mayoría de las preguntas se pueden responder allí.",
    },
    claim_edit_instructions:
        "Actualice cualquier campo de reclamación y luego haga clic en enviar en la parte inferior de esta página para actualizar su formulario de reclamación.",
    claim_edit_notice:
        '¿Ha presentado un reclamo? <a href="javascript:void(0);" id="editClaimBtn">Haga clic aquí</a> para editar su reclamo.',
    claim_edit_title: "Editar reclamo",
    claim_form_errors: "Hay errores en el formulario de reclamación.",
    claim_processing_email_error:
        "Su dirección de correo electrónico de contacto debe coincidir con la dirección de correo electrónico proporcionada en su selección de método de pago. Actualice su correo electrónico o número de teléfono principal en la sección Información de contacto para que coincida con su información de pago.",
    claim_processing_error:
        "Hubo un error al procesar su solicitud, actualice la página y vuelva a intentarlo.",
    claim_processing_phone_error:
        "Su número de teléfono de contacto debe coincidir con el número de teléfono proporcionado en su selección de método de pago.",
    claim_submit_error:
        "Hubo un error al enviar su reclamo, inténtelo de nuevo.",
    claim_submit_success: "Gracias, su reclamo ha sido enviado.",
    close: "Cerca",
    confirmation: "Confirmación",
    confirmation_page: {
        title: "Su formulario de reclamación se ha enviado correctamente.",
        upload_fail: "",
        print_note: "Por favor imprima esta página para sus archivos.",
        claim_details: {
            title: "Detalles de su reclamo",
            body: "INFORMACIÓN DEL RECLAMO",
            footer: '<p class="text-center fs-6">Si tiene alguna pregunta con respecto a su Reclamación, proporcione la ID de correlación enviada que se indica arriba y cuando se comunique con el Administrador del acuerdo.</p>',
            edit: "",
        },
    },
    confirmation_exclusion_page: {
        title: "Su solicitud de exclusión se ha enviado con éxito.",
        upload_fail: "",
        print_note: "Por favor imprima esta página para sus archivos.",
        claim_details: {
            title: "Sus detalles de exclusión",
            body: "INFORMACIÓN DEL EXCLUSIÓN",
            footer: '<p class="text-center fs-6">Si tiene alguna pregunta con respecto a su Solicitud de exclusión, comuníquese con el Administrador del Acuerdo.</p>',
            edit: "",
        },
    },
    confirmation_this_is_a_copy:
        "ESTA ES UNA COPIA DE SU FORMULARIO DE RECLAMO",
    confirmation_screen_additional: {
        title: "Aviso",
        body: '<p class="fw-bold">Recibirá una confirmación y una copia de su reclamación por correo electrónico, incluyendo su ID de reclamación enviada y su código de confirmación. No comparta su ID de reclamación ni su código de confirmación con nadie. Nunca le llamaremos para solicitarle esta información.</p><p>También puede imprimir esta pantalla para sus registros.</p><p>Si no lo hace reciba un correo electrónico de confirmación después de 3 días, verifique su filtro de correo no deseado.</p>',
    },
    contact_admin: "Póngase en contacto con el administrador",
    contact_us_category: "Categoría",
    contact_us_error_while_sending:
        "Ocurrió un error al enviar su mensaje. Por favor, inténtelo de nuevo más tarde.",
    contact_us_fill_required_fields:
        "Por favor llene todos los campos requeridos.",
    contact_us_rel_faqs: "Preguntas frecuentes relevantes",
    contact_us_confirm: "¿Responde esto a tu pregunta?",
    contact_us_select_a_reason: "Seleccione una razón",
    contact_us_select_dropdown: {
        claim_form: "Formulario de reclamación",
        contact_info_update: "Actualización de información de contacto",
        exclusion: "Exclusión y Opt-Out",
        general_qa: "Pregunta general sobre el Acuerdo",
        notice_related: "Aviso relacionado",
        other: "Otro",
        payment: "Pago",
        status: "Estado",
    },
    contact_us_select_other: "Otro",
    contact_us_success: "Tu mensaje ha sido enviado exitosamente.",
    contact_us: "Contacto",
    custom_fb_association:
        "Ingrese al menos un correo electrónico, número de teléfono o nombre de usuario asociado con su cuenta de Facebook.",
    date: "Fecha",
    deadline_claim: "La fecha límite para presentar un Reclamo ha pasado.",
    deadline_exclude: "La fecha límite para enviar una exclusión ha pasado.",
    transaction_add_row: "Agregar ",
    transaction_delete_row: "Borrar fila",
    email_address: "Dirección de correo electrónico",
    error: "Error",
    error_403:
        "La configuración y/o uso actual de su computadora viola nuestras políticas de seguridad. Deshabilite las VPN o pruebe en un dispositivo diferente.",
    example: "Ejemplo",
    exclusion_form_top_notice:
        "Al enviar este Formulario de exclusión, estoy solicitando la exclusión de este Acuerdo y no recibiré un pago del Acuerdo.",
    exclusion_form_error:
        "Hay errores en el formulario de solicitud de exclusión.",
    exclusion_submit_error:
        "Hubo un error al enviar su solicitud de exclusión, actualice la página y vuelva a intentarlo.",
    exclusion_submit_success:
        "Su solicitud de exclusión se ha enviado correctamente.",
    first_name: "Nombre",
    faq_page_aria_title: "Preguntas frecuentes",
    important_dates: "Fechas importantes",
    last_name: "Apellido",
    locale: "es-MX",
    long_date: "AUDIENCIA DE APROBACIÓN DEFINITIVA",
    message: "Mensaje",
    nav_submit_claim_button: "Enviar reclamo",
    no: "No",
    not_eligible_submit_claim:
        "Usted no es elegible para presentar un reclamo.",
    notice: "Aviso",
    official_banner_text:
        "Este es el sitio web oficial del acuerdo de {SiteName} autorizado por {CourtName}.",
    official_banner_aria: "Aviso oficial del sitio web del acuerdo",
    payment_select_email_disclaimer:
        "Asegúrese de que el correo electrónico o el número de teléfono que proporcione para recibir el pago coincida con su información de contacto anterior.",
    payment_select_error: "Por favor seleccione un método de pago.",
    payment_update_message:
        'Ha solicitado correctamente un <span id="previous_payment_method"></span> pago. <span id="update_payment_toggle">Haga clic aquí si desea elegir un método de pago diferente.</span>',
    phone_number_1: "Número de teléfono",
    claim_id_if_known: "ID de Reclamo (si lo conoce)",
    privacy_policy_url:
        "https://angeion-public.s3.amazonaws.com/docs/Privacy_Policy.pdf",
    privacy_policy: "Política de privacidad",
    reason_select: "Seleccione una razón",
    reason: "Razón",
    required: "Requerido",
    return_to_home: 'Regrese a la <a href="home">página de inicio</a>.',
    signature: "Firma",
    signature_placholder: "ESCRIBE SU NOMBRE COMPLETO",
    signature_ueta_title: "Aviso de firma electrónica",
    signature_ueta_compliant:
        "Al escribir su nombre a continuación y enviar este formulario, acepta que esto constituye su firma electrónica.",
    submit_btn: "Enviar",
    submitting: "Sumisión...",
    topic: "Tema",
    version: "Versión",
    yes: "Sí",
    vpn_cors_error:
        '<div class="vpn-error-container"><p>Lo sentimos, pero no pudimos procesar su solicitud debido a una restricción de seguridad o un problema de red.</p><p>Esto puede deberse a:</p><ul><li>Su dirección IP proviene de una región geográfica restringida</li><li>Está usando una VPN, proxy o servicio de anonimización</li><li>Su conexión activó una regla de seguridad diseñada para proteger nuestros sistemas</li><li>Hubo un problema al acceder a nuestros servidores (por ejemplo, error del navegador o conexión)</li></ul><p>Si cree que esto fue un error y necesita acceso, comuníquese con nuestro equipo de soporte y proporcione lo siguiente:</p><ul><li>Su dirección IP</li><li>La fecha y hora del problema</li><li>Una breve descripción de lo que estaba intentando acceder</li></ul><p>Gracias por su comprensión y cooperación.</p></div>',
    access_issue_detected: "Se detectó un problema de acceso",
};
